import { useState } from "react";
import { useMapEvents } from "react-leaflet";
import { pickActiveRasterTypename } from "../utils/activeRasterTypename";

/**
 * Nome da camada a pedir ao GeoServer no zoom atual: rasters com versão
 * detalhada trocam de typename a partir do limiar. Fica num hook porque mais de
 * um renderizador precisa da mesma escolha — se cada um decidisse por si, o
 * caminho filtrado perderia a troca que o caminho normal faz.
 */
export function useActiveRasterTypename(
  typename: string,
  detailedLayerName?: string,
  detailedLayerZoomThreshold = 12
): string {
  const map = useMapEvents({
    zoomend: (e) => setZoom(e.target.getZoom()),
  });
  const [zoom, setZoom] = useState<number>(() => map.getZoom());

  return pickActiveRasterTypename(
    zoom,
    typename,
    detailedLayerName,
    detailedLayerZoomThreshold
  );
}
